const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearAllSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6772"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157511",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.907-917.084a1.7 1.7 0 0 1 1.247.511 1.7 1.7 0 0 1 .511 1.247v10.763h-.419l-1.04-1.04v-9.723a.291.291 0 0 0-.084-.215.291.291 0 0 0-.215-.084h-9.652l-.914-.914a1.661 1.661 0 0 1 .566-.4 1.749 1.749 0 0 1 .706-.142zm-2.2 8.945-2.136-2.13a1.777 1.777 0 0 1 .605-.816 1.566 1.566 0 0 1 .975-.323 1.61 1.61 0 0 1 1.182.493 1.616 1.616 0 0 1 .492 1.184 1.646 1.646 0 0 1-.308.978 1.663 1.663 0 0 1-.817.614zm-6.232 2v-5.491l2.6 2.6a4.37 4.37 0 0 1-.661 2.125 1.629 1.629 0 0 1-1.387.768zm-3.993 6.076h13.5l-1.159-1.159H54.779a.291.291 0 0 0-.215.084.291.291 0 0 0-.084.215zm16.328 2.833-1.376-1.376H53.021v-2.319a1.693 1.693 0 0 1 .516-1.242 1.693 1.693 0 0 1 1.242-.516h10.578l-8.044-8.059v6.413h-1.459v-7.871l-4-4 1.025-1.025L71.85-898.27zm-9.575-2.835zm.993-10.554zm-1.704 3.079z",
    transform: "translate(-47.85 921.23)",
    style: {
      fill: "#030814"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAllSelected);
export default __webpack_public_path__ + "static/media/clear_all_selected.c93564e7fc6faec86ba3b6172eaa7b30.svg";
export { ForwardRef as ReactComponent };